<div class="container-fluid px-0">
    <terra-form-container
        [sortByPosition]="sortByPosition"
        [inputFormFields]="_formFields"
        [inputIsDisabled]="inputIsDisabled"
        [inputScope]="scope"
        [inputFormGroup]="formGroup"
        [inputControlTypeMap]="_controlTypeMap"
        [width]="_width"
    >
    </terra-form-container>
</div>
